import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SmService {
  http: HttpClient;
  constructor(http: HttpClient) {
    this.http = http;
  }

  defaultAssignmentsGet(checklistTemplateID: number) {
    var url = "/SM/DefaultAssignmentsGet?checklistTemplateID=" + checklistTemplateID;
    return this.http.get(url).toPromise();
  }

  defaultAssignmentGetChoices(assignType: string) {
    var url = "/SM/DefaultAssignmentGetChoices?assignType=" + assignType;
    return this.http.get(url).toPromise();
  }

  defaultAssignmentAddEdit(checklistDefaultAssignID: number, checklistTemplateID: number, assignType: string, assignValue: string, completeRequired?: boolean) {
    return this.http.post("/SM/DefaultAssignmentAddEdit",
      {
        checklistDefaultAssignID: checklistDefaultAssignID,
        checklistTemplateID: checklistTemplateID,
        assignType: assignType,
        assignValue: assignValue,
        completeRequired: completeRequired
      }).toPromise();
  }

  defaultAssignmentRemove(checklistDefaultAssignID: number, checklistTemplateID: number) {
    return this.http.post("/SM/DefaultAssignmentRemove",
      {
        checklistTemplateID: checklistTemplateID,
        checklistDefaultAssignID: checklistDefaultAssignID
      }).toPromise();
  }

  getTechnicians(sMCo?: number) {
    var url = "/SM/GetTechnicians" + (sMCo != null ? "?sMCo=" + sMCo : "");
    return this.http.get(url).toPromise();
  }

  getWorkOrderTrips(extendURL: string) {
    var url = "/SM/GetWorkOrderTrips" + extendURL;
    return this.http.get(url).toPromise();
  }

  getClockInStatus() {
    var url = "/SM/GetClockInStatus";
    return this.http.get(url).toPromise();
  }

  getSignerContacts(sMWorkOrderID: any, sMTripID: any) {
    var url = "/SM/GetSignerContacts?sMWorkOrderID=" + sMWorkOrderID + "&sMTripID=" + sMTripID;
    return this.http.get(url).toPromise();
  }

  getCommonLookups(extendURL: string) {
    var url = "/SM/GetCommonLookups" + extendURL
    return this.http.get(url).toPromise();
  }

  getSettingsBySMCo(sMCo: number) {
    var url = "/SM/GetSettingsBySMCo?sMCo=" + sMCo;
    return this.http.get(url).toPromise();
  }

  syncAll(fromDate: any, toDate: any, isUnscheduled: any) {
    var url = "/SM/SyncAll?fromTripDateStr=" + fromDate + "&toTripDateStr=" + toDate + "&includeUnscheduled=" + isUnscheduled;
    return this.http.get(url).toPromise();
  }

  getVPAttachmentList(uniqueAttchID: any, includeData: any) {
    var url = "/Document/GetVPAttachmentList?uniqueAttchID=" + uniqueAttchID + "&includeData=" + includeData;
    return this.http.get(url).toPromise();
  }

  getWorkCompleted(extendURL: string) {
    var url = "/SM/GetWorkCompleted" + extendURL;
    return this.http.get(url).toPromise();
  }

  getFormTemplateOptions(SMWorkOrderScopeID: any) {
    var url = "/SM/GetFormTemplateOptions?sMWorkOrderScopeID=" + SMWorkOrderScopeID;
    return this.http.get(url).toPromise();
  }

  getFormsPerScope(extendURL: string) {
    var url = "/SM/GetFormsPerScope" + extendURL;
    return this.http.get(url).toPromise();
  }

  getWorkOrderScopes(extendURL: string) {
    var url = "/SM/GetWorkOrderScopes" + extendURL;
    return this.http.get(url).toPromise();
  }

  getScopePurchaseOrders(extendURL: string) {
    var url = "/SM/GetScopePurchaseOrders" + extendURL;
    return this.http.get(url).toPromise();
  }

  getScopeTasks(extendURL: string) {
    var url = "/SM/GetScopeTasks" + extendURL;
    return this.http.get(url).toPromise();
  }

  workOrderScopeInsertUpdate(data: any) {
    return this.http.post("/SM/WorkOrderScopeInsertUpdate",
      {
        sMWorkOrderID: data.sMWorkOrderID, sMWorkOrderScopeID: data.sMWorkOrderScopeID, sMWorkScope: data.sMWorkScope,
        priority: data.priority, scopeDetails: data.scopeDetails, sMCallType: data.sMCallType,
        serviceItem: data.serviceItem, sMScopeNotes: data.sMScopeNotes, phase: data.phase
      }).toPromise();
  }

  getEQSIMA(extendURL: any) {
    var url = extendURL;
    return this.http.get(url).toPromise();
  }

  getRevCode(extendURL: string) {
    var url = "/SM/GetEquipRevCode" + extendURL;
    return this.http.get(url).toPromise();
  }

  insertUpdateSMWorkCompleted(data: any) {
    return this.http.post("/SM/InsertUpdateSMWorkCompleted",
      {
        sMWorkOrderScopeID: data.sMWorkOrderScopeID, sMWorkCompletedID: data.sMWorkCompletedID,
        dateStr: data.dateStr, lineType: data.lineType, nonBillable: data.nonBillable,
        serviceItem: data.serviceItem, sMCostType: data.sMCostType, technician: data.technician, pRHoursWorked: data.pRHoursWorked,
        pRBillableHours: data.pRBillableHours, pRPayType: data.pRPayType, pRLaborCode: data.pRLaborCode, eMEMKeyID: data.eMEMKeyID,
        revCode: data.revCode, eQUnits: data.eQUnits, standardItem: data.standardItem, notes: data.notes,
        startTime: data.startTime, stopTime: data.stopTime, isClockOut: data.isClockOut, breakHours: data.breakHours,
        costQty: data.costQty, iNCo: data.iNCo, iNLMKeyID: data.iNLMKeyID,
        materical: data.materical, gPSLat: data.gPSLat, gPSLong: data.gPSLong, isNewItem: data.isNewItem, tempType: data.tempType,
        NewMiscStandardItem: data.NewMiscStandardItem, NewINMaterial: data.NewINMaterial, NewEMEMKeyID: data.NewEMEMKeyID
      }).toPromise();
  }

  deleteSMWorkCompleted(sMWorkCompletedID: any) {
    return this.http.post("/SM/DeleteSMWorkCompleted",
      {
        sMWorkCompletedID: sMWorkCompletedID
      }).toPromise();
  }

  updateTripNotes(sMTripID: any, tripNotes: any, workOrderDescription: any, tripDescription: any) {
    return this.http.post("/SM/UpdateTripNotes",
      {
        sMTripID: sMTripID, tripNotes: tripNotes, workOrderDescription: workOrderDescription, tripDescription: tripDescription
      }).toPromise();
  }

  updateTripStatus(sMTripID: any, tripStatus: any) {
    return this.http.post("/SM/UpdateTripStatus",
      {
        sMTripID: sMTripID, tripStatus: tripStatus
      }).toPromise();
  }

  createNewForm(checklistTemplateID: any, sMWorkOrderScopeID: any, sMTripID: any) {
    return this.http.post("/SM/CreateNewForm", {
      checklistTemplateID: checklistTemplateID, sMWorkOrderScopeID: sMWorkOrderScopeID, sMTripID: sMTripID
    }).toPromise();
  }

  deleteForm(scopeChecklistInstanceID: any) {
    return this.http.post("/SM/DeleteForm", {
      scopeChecklistInstanceID: scopeChecklistInstanceID
    }).toPromise();
  }

  updateScopeTask(sMWorkOrderScopeID: any, sMScopeTaskID: any, completed: any) {
    return this.http.post("/SM/UpdateScopeTask", {
      sMWorkOrderScopeID: sMWorkOrderScopeID, sMScopeTaskID: sMScopeTaskID, completed: completed
    }).toPromise();
  }

  updateSettings(enableOfflineFS: any) {
    return this.http.post("/SM/UpdateSettings", {
      enableOfflineFS: enableOfflineFS
    }).toPromise();
  }

  pPOInsert(sMWorkOrderScopeID: any, pODescription: any, userPONumber: any, pORoughAmount: any, aPVMKeyID: any, requestDateStr: any, sMCostType: any) {
    return this.http.post("/SM/POInsert", {
      sMWorkOrderScopeID: sMWorkOrderScopeID, pODescription: pODescription, userPONumber: userPONumber, pORoughAmount: pORoughAmount, aPVMKeyID: aPVMKeyID,
      requestDateStr: requestDateStr, sMCostType: sMCostType
    }).toPromise();
  }

  getFormsPerScopeMulti(sMWorkOrderScopeID: any, sMTripID: any): any {
    return this.http.post("/SM/GetFormsPerScopeMulti", { sMWorkOrderScopeID: sMWorkOrderScopeID, sMTripID: sMTripID }).toPromise();
  }

  completeTrip(data: any) {
    return this.http.post("/SM/CompleteTrip", {
      sMTripID: data.sMTripID, sMWorkOrderID: data.sMWorkOrderID, revisitRequired: data.revisitRequired, revisitReason: data.revisitReason, revisitNotes: data.revisitNotes,
      signatureImage: data.signatureImage, signatureLat: data.signatureLat, signatureLong: data.signatureLong, hQContactID: data.hQContactID, firstName: data.firstName, lastName: data.lastName,
      title: data.title, email: data.email, scopes: data.scopes, unique: data.unique, fileName: data.fileName, emailList: data.emailList, subject: data.subject, justComplete: data.justComplete,
      sMCO: data.sMCO, phone: data.phone, ccEmailList: data.ccEmailList, justSendEmail: data.justSendEmail, trip: data.trip, techName: data.techName, companyName: data.companyName
    }).toPromise();
  }

  getServiceItemDetails(sMServiceSiteID: any, sMServiceItemID: any) {
    return this.http.get("/SM/GetServiceItemDetails?" + (sMServiceSiteID != null ? "sMServiceSiteID=" + sMServiceSiteID : "sMServiceItemID=" + sMServiceItemID)).toPromise();
  }

  serviceItemWOHistory(sMServiceSiteID: any, sMTripID: any, sMServiceItemID: any) {
    return this.http.get("/SM/ServiceItemWOHistory?sMTripID=" + sMTripID + (sMServiceSiteID != null ? "&sMServiceSiteID=" + sMServiceSiteID : "") + (sMServiceItemID != null ? "&sMServiceItemID=" + sMServiceItemID : "")).toPromise();
  }

  updateSiteNotes(sMServiceSiteID: any, siteNotes: any) {
    return this.http.post("/SM/UpdateSiteNotes", { sMServiceSiteID: sMServiceSiteID, siteNotes: siteNotes }).toPromise();
  }

  getCustomers(SMCo: any) {
    return this.http.get("/SM/GetCustomers?sMCo=" + SMCo + "&includeInactive=false").toPromise();
  }

  getSitesByCustomer(queryStrArr: any) {
    return this.http.get("/SM/GetSitesByCustomer?" + queryStrArr).toPromise();
  }

  getServiceCenters(SMCo: any) {
    return this.http.get("/SM/GetServiceCenters?sMCo=" + SMCo + "&includeInactive=false").toPromise();
  }

  workOrderInsertUpdate(data) {
    return this.http.post("/SM/WorkOrderInsertUpdate", {
      sMCo: data.sMCo, sMWorkOrderID: data.sMWorkOrderID, sMCustomerID: data.sMCustomerID, sMServiceSiteID: data.sMServiceSiteID, workOrderDescription: data.workOrderDescription, requestedBy: data.requestedBy,
      requestedByPhone: data.requestedByPhone, contactName: data.contactName, contactPhone: data.contactPhone, leadTechnician: data.leadTechnician,
      serviceCenter: data.serviceCenter, sMWorkOrderNotes: data.sMWorkOrderNotes, includeUnscheduled: data.includeUnscheduled, sMTripID: data.sMTripID, workOrder: data.workOrder, sMCallType: data.sMCallType, division: data.division
    }).toPromise();
  }

  serviceItemInsertUpdate(sMServiceItemID: any, sMCo: any, serviceSite: any, serviceItem: any, itemDescription: any, manufacturer: any, model: any, yearManufactured: any, location: any,
    sMTypeID: any, serialNumber: any, active: any, serviceItemSummary: any, QRCodeID: any) {
    return this.http.post("/SM/ServiceItemInsertUpdate", {
      sMServiceItemID: sMServiceItemID, sMCo: sMCo, serviceSite: serviceSite, serviceItem: serviceItem, itemDescription: itemDescription, manufacturer: manufacturer, model: model,
      yearManufactured: yearManufactured, location: location, sMTypeID: sMTypeID, serialNumber: serialNumber, active: active, serviceItemSummary: serviceItemSummary, QRCodeID: QRCodeID
    }).toPromise();
  }

  getServiceItemParts(sMServiceItemID: any, sMServiceSiteID: any) {
    var url = "/SM/GetServiceItemParts?sMServiceItemID=" + sMServiceItemID + "&sMServiceSiteID=" + sMServiceSiteID;
    return this.http.get(url).toPromise();
  }

  saveTripSignatureList(sMTripID: any, sMWorkOrderID: any, sMScopesString: any, signatureImage: any, signatureLat: any, signatureLong: any, hQContactID: any, firstName: any, lastName: any, title: any,
    email: any, phone: any) {
    return this.http.post("/SM/SaveTripSignatureList", {
      sMTripID: sMTripID, sMWorkOrderID: sMWorkOrderID, sMScopesString: sMScopesString, signatureImage: signatureImage, signatureLat: signatureLat,
      signatureLong: signatureLong, hQContactID: hQContactID, firstName: firstName, lastName: lastName, title: title, email: email, phone: phone
    }).toPromise();
  }

  invoiceProcess(sMWorkOrderID: any, sMScopeExcludeList: any, paymentRef: any) {
    return this.http.post("/SM/InvoiceProcess", {
      sMWorkOrderID: sMWorkOrderID, sMScopeExcludeList: sMScopeExcludeList, paymentRef: paymentRef
    }).toPromise();
  }

  tripInsertUpdate(sMWorkOrderID: any, sMTripID: any, tripDescription: any, technician: any, scheduledDateStr: any, scheduleTimeStr: any, isWODashboard: any, tripNotes: any) {
    return this.http.post("/SM/TripInsertUpdate", {
      sMWorkOrderID: sMWorkOrderID, sMTripID: sMTripID, tripDescription: tripDescription, technician: technician, scheduledDateStr: scheduledDateStr, scheduleTimeStr: scheduleTimeStr, isWODashboard: isWODashboard, tripNotes: tripNotes
    }).toPromise();
  }

  getSignatures(sMTripID: any, sMScopeString: any) {
    var url = "/SM/GetSignatures?sMTripID=" + sMTripID + "&sMScopeString=" + sMScopeString;
    return this.http.get(url).toPromise();
  }

  getVPAttachmentData(attachmentID: any) {
    var url = "/DailyReports/GetVPAttachmentData?attachmentID=" + attachmentID + "&turnOnMaxWidth=false"
    return this.http.get(url).toPromise();
  }

  getVCMttachmentData(contentTypeName: any, docID: any) {
    var url = "/DailyReports/GetVCMttachmentData?contentTypeName=" + contentTypeName + "&docID=" + docID
    return this.http.get(url).toPromise();
  }

  updateVPAttachment(attachmentID: any, fileDescription: any, attachmentTypeID: any, sMWorkOrderScopeID: any) {
    return this.http.post("/SM/UpdateVPAttachment", {
      attachmentID: attachmentID, fileDescription: fileDescription, attachmentTypeID: attachmentTypeID, sMWorkOrderScopeID: sMWorkOrderScopeID
    }).toPromise();
  }

  getServiceItemIDByQRCode(qrCodeID: any) {
    var url = "/SM/GetServiceItemIDByQRCode?qrCodeID=" + qrCodeID
    return this.http.get(url).toPromise();
  }

  offlinePost(url: any, data: any) {
      return this.http.post(url, data).toPromise();
  }

  getCompanies() {
    var url = "/SM/GetCompanies";
    return this.http.get(url).toPromise();
  }

  getServiceWorkOrders(queryStrArr: any) {
    var url = "/SM/GetServiceWorkOrders?" + queryStrArr.join("&");
    return this.http.get(url).toPromise();
  }

  getTripsByWorkOrder(sMWorkOrderID?: number) {
    var url = "/SM/GetTripsByWorkOrder?sMWorkOrderID=" + sMWorkOrderID;
    return this.http.get(url).toPromise();
  }

  getTripSignatures(sMTripID?: number) {
    var url = "/SM/GetTripSignatures?sMTripID=" + sMTripID;
    return this.http.get(url).toPromise();
  }

}